export default () => {

    const tables = document.querySelectorAll('.element.content table');

    for (const table of tables) {

        const rowLabels = [];
        const firstRow = table.querySelector('tr:first-child');

        // do the TDs first
        for (const td of firstRow.querySelectorAll('td')) {
            rowLabels.push(td.innerText);
        }

        const ul = document.createElement('ul');
        ul.className = 'table-list';

        // all other rows
        const rows = table.querySelectorAll('tr');
        for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            const rowLi = document.createElement('li');
            const rowUl = document.createElement('ul');
            const tds = row.querySelectorAll('td');
            for (let j = 0; j < tds.length; j++) {
                const cellLi = document.createElement('li');
                const label = typeof rowLabels[j] !== 'undefined' ? rowLabels[j] : '';
                const value = tds[j].innerText;
                if (label) {
                    cellLi.innerHTML = '<label>' + label + ': </label> ' + value;
                } else {
                    cellLi.innerHTML = value;
                }
                rowUl.appendChild(cellLi);
            }

            rowLi.className = 'table-list__group';
            rowLi.appendChild(rowUl);
            ul.appendChild(rowLi);
        }

        table.insertAdjacentElement('beforebegin', ul);

    }

}
